import { useState } from "react";
import * as React from "react";
import { useFirestore } from "reactfire";
import { ToDoList } from "./ToDoList";
import { wordId } from "../idGenerate";

export const ListSelect = () => {
  const initialListID =
    window.location.hash.length > 1 ? window.location.hash.substr(1) : null;
  const [currentList, setcurrentList] = useState<string | null>(initialListID);
  const firestore = useFirestore();
  const createNewList = async () => {
    let id = wordId(3);
    while ((await firestore.collection("lists").doc(id).get()).exists) {
      id = wordId(3);
    }
    await firestore.collection("lists").doc(id).set({});
    setcurrentList(id);
    window.location.hash = id;
  };

  return (
    <div style={{ height: "100%" }}>
      {currentList == null ? (
        <div className="home_page" onClick={createNewList}>
          <p>Tap anywhere to create a new list</p>
        </div>
      ) : (
        <ToDoList listID={currentList} />
      )}
    </div>
  );
};
